import script from "./GiftboxView.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftboxView.vue?vue&type=script&setup=true&lang=js"

import "./GiftboxView.vue?vue&type=style&index=0&id=2bf3d9cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bf3d9cc"]])

export default __exports__